// import React, { useState, useEffect } from 'react';

// const OperatorList = () => {
//     const [users, setUsers] = useState([]);

//     const [formData, setFormData] = useState({
//         name: '',
//         phone_no: '',
//         gmail_id: '',
//         status: 1  
//     });

//     const fetchUsers = () => {
//         fetch("https://ims-backend.indevconsultancy.in/admin-panel/operators/")
//             .then(response => response.json())
//             .then(data => setUsers(data))
//             .catch(error => console.error("Error fetching users:", error));
//     };

//     useEffect(() => {
//         fetchUsers();
//     }, []);

//     const handleChange = (e) => {
//         setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();

//         if (!formData.name || !formData.phone_no || !formData.gmail_id) {
//             alert("Please fill all required fields.");
//             return;
//         }

//         fetch("https://ims-backend.indevconsultancy.in/admin-panel/operators/", {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(formData)
//         })
//         .then(res => {
//             if (!res.ok) throw new Error("Failed to save user.");
//             return res.json();
//         })
//         .then(() => {
//             fetchUsers(); // refresh list
//             setFormData({ name: '', phone_no: '', gmail_id: '' });

//             // close modal
//             const modal = document.getElementById('registerModal');
//             const instance = window.bootstrap.Modal.getInstance(modal);
//             instance.hide();
//         })
//         .catch(error => alert("Error saving user: " + error.message));
//     };

//     return (
//         <>
//             <div className="content">
//                 <div className="container-fluid">
//                     <div className="row g-3">
//                         <div className="col-md-12">
//                             <div className="card">
//                                 <div className="card-header border-info">
//                                     <form>
//                                         <div className="row g-3">
//                                             {/*  */}
//                                             <div className="col-lg">
//                                                 <select name="datefilter" className="form-select" id="datefilter">
//                                                     <option value="Last 7 days" selected="">Select</option>
//                                                 </select>
//                                             </div>
//                                             <div className="col-lg-2">
//                                                 <button type="submit" className="btn btn-primary w-100">Search</button>
//                                             </div>
//                                             <div className="col-lg-1">
//                                                 <a href="list.html" className="btn btn-outline-dark w-100">Reset</a>
//                                             </div>
//                                         </div>
//                                     </form>
//                                 </div>

//                                 <div className="card-body">
//                                     <div className="row g-0 align-items-center">
//                                         <div className="col-sm-7 mb-3">
//                                             <h6 className="fw-bold mb-0">
//                                                 Total User(s): <span>{users.length}</span>
//                                             </h6>
//                                         </div>
//                                         <div className="col-sm-5 mb-3 text-end">
//                                             <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#registerModal">
//                                                 Add User
//                                             </button>
//                                         </div>
//                                     </div>

//                                     <div className="table-responsive scrollbar">
//                                         <table className="table text-center table-bordered table-striped fs--1 mb-0">
//                                             <thead className="bg-primary text-white">
//                                                 <tr>
//                                                     <th>ID</th>
//                                                     <th>Name</th>
//                                                     <th>Phone No</th>
//                                                     <th>Email</th>
//                                                     <th>Status</th>
//                                                     <th>Action</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {users.length === 0 ? (
//                                                     <tr>
//                                                         <td colSpan="6">No users found.</td>
//                                                     </tr>
//                                                 ) : (
//                                                     users.map((user) => (
//                                                         <tr key={user.Kitchen_operator_id}>
//                                                             <td>{user.Kitchen_operator_id}</td>
//                                                             <td>{user.name}</td>
//                                                             <td>{user.phone_no}</td>
//                                                             <td>{user.gmail_id}</td>
//                                                             <td>{user.status === 1 ? 'Active' : 'Inactive'}</td>
//                                                             <td>
//                                                                 <button className="btn btn-sm btn-warning">Edit</button>
//                                                             </td>
//                                                         </tr>
//                                                     ))
//                                                 )}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Modal */}
//             <div className="modal fade" id="registerModal" tabIndex="-1" aria-labelledby="registerModalLabel" aria-hidden="true">
//                 <div className="modal-dialog modal-lg">
//                     <div className="modal-content">
//                         <form onSubmit={handleSubmit}>
//                             <div className="modal-header">
//                                 <h5 className="modal-title" id="registerModalLabel">Add User</h5>
//                                 <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
//                             </div>

//                             <div className="modal-body">
//                                 <div className="row g-3">
//                                     <div className="col-md-6">
//                                         <label className="form-label">Name</label>
//                                         <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} />
//                                     </div>
//                                     <div className="col-md-6">
//                                         <label className="form-label">Phone No</label>
//                                         <input type="text" className="form-control" name="phone_no" value={formData.phone_no} onChange={handleChange} />
//                                     </div>
//                                     <div className="col-md-6">
//                                         <label className="form-label">Email</label>
//                                         <input type="email" className="form-control" name="gmail_id" value={formData.gmail_id} onChange={handleChange} />
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="modal-footer">
//                                 <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
//                                 <button type="submit" className="btn btn-primary">Save User</button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default OperatorList;


import React, { useEffect, useState } from 'react';
import axios from 'axios';

const OperatorList = () => {
    const [users, setUsers] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        phone_no: '',
        gmail_id: '',
        status: 1
    });
    const [editIndex, setEditIndex] = useState(null);

    const API_URL = 'https://ims-backend.indevconsultancy.in/admin-panel/operators/';

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const res = await axios.get(API_URL);
            setUsers(res.data);
        } catch (error) {
            console.error("Error fetching users", error);
        }
    };

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name || !formData.phone_no || !formData.gmail_id) {
            alert("Please fill all required fields.");
            return;
        }

        try {
            if (editIndex !== null) {
                // You can enable PUT API call here if available
                const updatedUsers = [...users];
                updatedUsers[editIndex] = formData;
                setUsers(updatedUsers);
                setEditIndex(null);
            } else {
                const res = await axios.post(API_URL, formData);
                setUsers(prev => [...prev, res.data]);
            }

            setFormData({
                name: '',
                phone_no: '',
                gmail_id: '',
                status: 1
            });

            const modal = window.bootstrap.Modal.getInstance(document.getElementById('registerModal'));
            modal.hide();

        } catch (err) {
            console.error("Error saving user", err);
            alert("Error saving user. Check console.");
        }
    };

    const handleEdit = (index) => {
        const user = users[index];
        setFormData({
            name: user.name,
            phone_no: user.phone_no,
            gmail_id: user.gmail_id,
            status: user.status
        });
        setEditIndex(index);
        const modal = new window.bootstrap.Modal(document.getElementById('registerModal'));
        modal.show();
    };

    const handleDelete = async (index) => {
        if (!window.confirm("Are you sure you want to delete this user?")) return;
        const id = users[index].Kitchen_operator_id;

        try {
            await axios.delete(`${API_URL}${id}/`);
            setUsers(users.filter((_, i) => i !== index));
        } catch (error) {
            console.error("Delete error", error);
            alert("Failed to delete user.");
        }
    };

    return (
        <div className="container-fluid mt-4">
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h5>Total Users: {users.length}</h5>
                    <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#registerModal" onClick={() => {
                        setFormData({ name: '', phone_no: '', gmail_id: '', status: 1 });
                        setEditIndex(null);
                    }}>Add User</button>
                </div>
                {/* <div className="card-body">
                    <table className="table table-bordered table-striped text-center">
                        <thead className="bg-primary text-white">
                            <tr>
                                <th>S.No.</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.length === 0 ? (
                                <tr><td colSpan="5">No users found.</td></tr>
                            ) : (
                                users.map((user, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{user.name}</td>
                                        <td>{user.phone_no}</td>
                                        <td>{user.gmail_id}</td>
                                        <td>
                                            <button className="btn btn-sm btn-warning me-2" onClick={() => handleEdit(i)}>Edit</button>
                                            <button className="btn btn-sm btn-danger" onClick={() => handleDelete(i)}>Delete</button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div> */}
                <div className="card-body">
  <div className="table-responsive">
    <table className="table table-bordered table-striped text-center">
      <thead className="bg-primary text-white">
        <tr>
          <th>S.No.</th>
          <th>Name</th>
          <th>Phone</th>
          <th>Email</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {users.length === 0 ? (
          <tr>
            <td colSpan="5">No users found.</td>
          </tr>
        ) : (
          users.map((user, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{user.name}</td>
              <td>{user.phone_no}</td>
              <td>{user.gmail_id}</td>
              <td>
                <button
                  className="btn btn-sm btn-warning me-2"
                  onClick={() => handleEdit(i)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDelete(i)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
</div>

            </div>

            {/* Modal */}
            <div className="modal fade" id="registerModal" tabIndex="-1" aria-labelledby="registerModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h5 className="modal-title" id="registerModalLabel">{editIndex !== null ? 'Edit' : 'Add'} User</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">Name</label>
                                    <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Phone</label>
                                    <input type="text" className="form-control" name="phone_no" value={formData.phone_no} onChange={handleChange} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Gmail</label>
                                    <input type="email" className="form-control" name="gmail_id" value={formData.gmail_id} onChange={handleChange} />
                                </div>
                                <input type="hidden" name="status" value="1" />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">{editIndex !== null ? 'Update' : 'Save'} User</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OperatorList;

